import React from "react";
import { ModalStyle, PopupDiv, Button, MediumFont } from "./Style";
import { useAccessibility } from "../../contexts/AccessibilityContext";

export default function AccessibilityPanel() {
  const {
    enabled,
    setEnabled,
    fontScale,
    setFontScale,
    highContrast,
    setHighContrast,
    closePanel,
    isPanelOpen,
  } = useAccessibility();

  if (!isPanelOpen) return null;

  return (
    <ModalStyle
      className="animate__animated animate__fadeIn"
      onClick={closePanel}
    >
      <PopupDiv
        onClick={(e) => e.stopPropagation()}
        style={{
          padding: "24px 20px",
          maxWidth: 320,
          alignItems: "stretch",
          gap: 20,
        }}
      >
        <MediumFont
          style={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: "1.2rem",
          }}
        >
          נגישות
        </MediumFont>

        {/* הפעל / כבה */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <span style={{ fontSize: 15 }}>הפעל נגישות</span>
          <button
            type="button"
            role="switch"
            aria-checked={enabled}
            onClick={() => setEnabled(!enabled)}
            style={{
              width: 48,
              height: 26,
              borderRadius: 13,
              border: "2px solid #ccc",
              background: enabled ? "#5377bb" : "#e0e0e0",
              cursor: "pointer",
              position: "relative",
              transition: "background 0.2s",
            }}
          >
            <span
              style={{
                position: "absolute",
                top: 2,
                right: enabled ? 2 : 22,
                left: enabled ? "auto" : 22,
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "#fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                transition: "right 0.2s, left 0.2s",
              }}
            />
          </button>
        </div>

        {enabled && (
          <>
            <div style={{ borderTop: "1px solid #ddd", paddingTop: 16 }}>
              <MediumFont
                style={{
                  display: "block",
                  marginBottom: 10,
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                גודל גופן
              </MediumFont>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {[
                  { value: "normal", label: "רגיל" },
                  { value: "large", label: "גדול" },
                  { value: "xlarge", label: "גדול מאוד" },
                ].map(({ value, label }) => (
                  <button
                    key={value}
                    type="button"
                    onClick={() => setFontScale(value)}
                    style={{
                      padding: "8px 14px",
                      borderRadius: 8,
                      border:
                        fontScale === value
                          ? "2px solid #5377bb"
                          : "1px solid #ccc",
                      background: fontScale === value ? "#e8eeff" : "#fff",
                      color: fontScale === value ? "#5377bb" : "#333",
                      cursor: "pointer",
                      fontSize: 14,
                    }}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
              }}
            >
              <span style={{ fontSize: 15 }}>ניגודיות גבוהה</span>
              <input
                type="checkbox"
                checked={highContrast}
                onChange={(e) => setHighContrast(e.target.checked)}
                style={{ width: 20, height: 20, cursor: "pointer" }}
                id="accessibility-contrast"
              />
            </div>
          </>
        )}

        <Button
          background="rgb(223, 223, 223)"
          color="#3A3C3F"
          hoverColor="#3A3C3F"
          onClick={closePanel}
          style={{ marginTop: 8 }}
        >
          סגור
        </Button>
      </PopupDiv>
    </ModalStyle>
  );
}
